<template>
  <div class="box">
    <div class="addressBox">
      <span class="address_text1">收货地址：</span>
      <el-select v-model="value" placeholder="请选择">
        <el-option v-for="(item, index) in options" :key="index" :label="JSON.parse(item.address).label" :value="JSON.parse(item.address).label">
        </el-option>
      </el-select>
      <el-link type="primary" :underline="false" style="margin-left: 11px" @click="showDialog()">新增收货地址</el-link>
    </div>
    <div class="table_head">
      <el-checkbox value="false" disabled style="width: 210px">全选</el-checkbox>
      <span style="width: 350px">商品名称</span>
      <span style="width: 180px">数量</span>
      <span style="width: 150px">单价</span>

      <span style="width: 150px">金额</span>
      <span style="width: 104px">操作</span>
    </div>
    <div class="tableBox">
      <div class="tableBox_list" v-for="(item, index) in goodsListArr" :key="index" v-if="item.info.wholesalePrice">
        <el-checkbox v-model="item.info.isSelected" style="width: 35px" @change="changeStatus(item.id, item.info)" :disabled="item.info.status != 1||item.info.isPcGoods!=1"></el-checkbox><img :src="item.info.thumb" alt="" style="
            width: 121px;
            height: 121px;
            margin-right: 54px;
            cursor: pointer;
          " @click="gotoDetails(item.info.id)" />
        <div class="tableBox_name" @click="gotoDetails(item.info.id)">
          <div class="tableBox_nameText1">
            {{ item.info.title }}
          </div>
          <div class="tableBox_nameText2">
            {{ item.info.subtitle }}
          </div>
        </div>
        <div class="tableBox_number">
          <!-- <div class="tableBox_numIpt">
            {{ item.info.num }}
          </div> -->
          <input type="text" class="tableBox_numIpt" oninput="value=value.replace(/[^\d]/g,'')" @change="changeNum(index, item.id, item.info)" v-model.number="item.info.num" :disabled="item.info.status != 1||item.info.isPcGoods!=1" />
          <div class="tableBox_numBtnBox">
            <button class="tableBox_numAdd" style="transform: rotate(180deg)" @click="addNum(index, item.id, item.info)" :disabled="item.info.status != 1||item.info.isPcGoods!=1">
              <i class="iconfont">&#xe624;</i>
            </button>
            <button class="tableBox_numAdd" @click="reduceNum(index, item.id, item.info)" :disabled="item.info.status != 1||item.info.isPcGoods!=1">
              <i class="iconfont">&#xe624;</i>
            </button>
          </div>
          <span>{{ item.info.unit }}</span>
        </div>
        <div class="tableBox_price" v-if="goodsListArr.length > 0">
          <div class="tableBox_priceText1">
            <span style="font-size: 14px">￥</span>{{ item.info.wholesalePrice.toFixed(2) }}
          </div>
          <!-- <div class="tableBox_priceText2" >
            ￥{{  item.info.pcProductPrice.toFixed(2) }}
          </div> -->
        </div>
        <div class="tableBox_price">
          <div class="tableBox_priceText1" v-if="goodsListArr.length > 0">
            <span style="font-size: 14px">￥</span>{{ (item.info.wholesalePrice * item.info.num).toFixed(2) }}
          </div>
        </div>
        <div class="tableBox_action">
          <el-link :underline="false" class="tableBox_actionText" @click="deleteGoods(index, item.id)">删除</el-link>
          <el-link :underline="false" class="tableBox_actionText" @click="addCollect(item.info)" :disabled="item.info.status != 1||item.info.isPcGoods!=1">加入收藏</el-link>
        </div>
      </div>
      <el-empty description="暂无数据" v-if="goodsListArr.length == 0"></el-empty>
    </div>
    <div class="table_foot">
      <div class="table_footL">
        <el-checkbox v-model="selectedAll" style="width: 98px" @change="selectAll">全选</el-checkbox>
        <el-link :underline="false" @click="deleteAll()">删除</el-link>
      </div>
      <div class="table_footR">
        <span style="margin-right: 56px">数量总计{{ totalNum }}件</span>
        <span style="margin-right: 39px">合计(包运费)：<span style="color: #ff4019">￥{{ goodsPrice.toFixed(2) }}</span></span>

        <el-button type="primary" style="border-radius: 0; width: 169px !important; height: 100%" @click="goSettle()">去结算（{{ goodsNum }}）</el-button>
      </div>
    </div>
    <el-dialog title="新增收货地址" :visible.sync="dialogVisible" width="767px" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" label-position="top">
        <el-form-item label="收货人：" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入收货人" style="width: 270px" @input="ruleForm.name = ruleForm.name.replace(/\s+/g, '')"></el-input>
        </el-form-item>
        <el-form-item label="所在地区：" prop="area">
          <area-select v-if="isShowArea" v-model="ruleForm.area" :data="$pcaa" :level="3" style="display: flex; line-height: 18px" type="all"></area-select>
        </el-form-item>

        <el-form-item label="详细地址：" prop="address">
          <el-input v-model="ruleForm.address" placeholder="请输入详细地址" style="width: 622px" @input="ruleForm.address = ruleForm.address.replace(/\s+/g, '')"></el-input>
        </el-form-item>
        <el-row :gutter="15">
          <el-col :span="5"><el-form-item label="手机号码：" prop="phone">
              <el-input v-model="ruleForm.phone" placeholder="请输入手机号码"></el-input> </el-form-item></el-col>
          <!-- <el-col :span="1" style="text-align:center;margin-top: 60px"
            >或
          </el-col>
          <el-col :span="5"
            ><el-form-item label="固定电话：" prop="telephone">
              <el-input
                v-model="ruleForm.telephone"
                placeholder="请输入固定电话"
              ></el-input> </el-form-item
          ></el-col> -->
        </el-row>
        <el-checkbox v-model="isDefaultAdr">设为默认地址</el-checkbox>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetForm('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示信息" :visible.sync="noPermission" width="548px" :before-close="handleClose">
      <div class="modalText">
        对不起，您无权操作该页面，需完善信息并由后台审核通过后台方可操作，<span style="color: #f89a00">去完善</span>如已通过审核，请退出后重新登录。
      </div>
      <el-button type="primary" style="margin: 70px 0 0 50%; transform: translate(-50%, 0); width: 78px" @click="noPermission = false">确定</el-button>
    </el-dialog>
  </div>
</template>

<script>
import { doGet, doPost } from "../common/HttpHelper.js";
import { httpConfig } from "../common/config.js";
export default {
  data() {
    return {
      goodsListArr: [],
      collectList: [], //收藏列表
      isShowArea: true,
      options: [], //收货地址列表
      value: "", //选中的收货地址
      goodsNum: 0,
      totalNum: 0,
      goodsPrice: 0,
      selectedAll: false, //是否全部选中
      dialogVisible: false,
      noPermission: false,
      ruleForm: {
        name: "",
        area: [],
        address: "",
        phone: "",
        // telephone: ""
      },
      rules: {
        name: [{ required: true, message: "请输入收货人", trigger: "blur" }],
        city: [{ required: true, message: "请选择所在市", trigger: "change" }],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
        area: [
          { required: true, message: "请选择所在地区", trigger: "change" },
        ],
        phone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          {
            pattern:
              /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        // telephone: [
        //   { required: true, message: "请输入固定电话", trigger: "blur" }
        // ]
      },
      isDefaultAdr: false,
    };
  },
  mounted() {
    this.getAddressList();
    this.getShopCar(0); //获取购物车列表
    this.getShopCar(1); //获取收藏夹列表
  },
  methods: {
    /**
     * 获取购物车和收藏夹
     */
    getShopCar(type) {
      var that = this;
      doGet(
        httpConfig.shopCar.getShopCarUrl,
        { type },
        function (res) {
          if (res.flag) {
            if (type == 0) {
              that.goodsListArr = res.data;
              that.goodsListArr.forEach((item) => {
                item.info = JSON.parse(item.info);
              });
              if (that.goodsListArr.length > 0) {
                that.getNewPrice(); //更新购物车价格
              }
            } else {
              that.collectList = res.data;
              that.collectList.forEach((item) => {
                item.info = JSON.parse(item.info);
              });
              that.$store.commit("saveCollectNum", that.collectList.length);
            }
          }
        },
        function (res) {}
      );
    },
    /**
     * 更新购物车中商品信息
     */
    getNewPrice() {
      for (var i = 0; i < this.goodsListArr.length; i++) {
        this.getList(this.goodsListArr[i].info.id, i);
      }
    },
    /**
     * 获取商品详情
     */
    getList(id, index) {
      var that = this;
      doGet(
        httpConfig.GoodsInfo.getDataUrl,
        { goodsId: id },
        function (res) {
          if (res.flag) {
            var goodData = res.data;
            goodData.num = that.goodsListArr[index].info.num;
            goodData.isSelected = that.goodsListArr[index].info.isSelected;
            that.goodsListArr[index].info = goodData;
            var price = 0;
            for (let [ind, item] of goodData.intervalPriceList.entries()) {
              if (
                that.goodsListArr[index].info.num <
                goodData.intervalPriceList[0].startNum
              ) {
                price = item.price;
                that.goodsListArr[index].info.num =
                  goodData.intervalPriceList[0].startNum;

                that.editShopCar(
                  that.goodsListArr[index].id,
                  that.goodsListArr[index].info
                );
                break;
              } else if (
                ind == goodData.intervalPriceList.length - 1 &&
                that.goodsListArr[index].info.num >= item.startNum &&
                that.goodsListArr[index].info.num <= item.endNum
              ) {
                price = item.price;
                break;
              } else if (
                ind != goodData.intervalPriceList.length - 1 &&
                that.goodsListArr[index].info.num >= item.startNum
              ) {
                price = item.price;
                break;
              } else if (ind == goodData.intervalPriceList.length - 1) {
                price = item.price;
                that.goodsListArr[index].info.num = item.endNum;
                that.editShopCar(
                  that.goodsListArr[index].id,
                  that.goodsListArr[index].info
                );
                break;
              }
            }

            that.goodsListArr[index].info.wholesalePrice = price;
            that.getSelected();
          } else {
            // return;
            that.$message({
              type: "error",
              message: res.message,
            });
          }
        },
        function (res) {}
      );
    },
    /**
     * 判断是否被全选，计算选中的商品总数
     */
    getSelected(index) {
      this.goodsNum = 0;
      this.totalNum = 0;
      var price = 0;
      this.selectedAll = true;
      this.goodsListArr.forEach((item) => {
        this.totalNum += item.info.num;
        if (item.info.status == 1 && item.info.isPcGoods == 1) {
          if (item.info.isSelected == false) {
            this.selectedAll = false;
          } else {
            this.goodsNum += item.info.num;
            price += item.info.wholesalePrice * item.info.num;
          }
        } else {
          this.selectedAll = false;
        }
      });
      this.goodsPrice = price;
      if (this.goodsListArr.length == 0) {
        this.selectedAll = false;
      }
    },
    /**
     * 勾选单件商品
     */
    changeStatus(id, info) {
      this.editShopCar(id, info);
      this.getSelected();
    },
    /**
     * 全选
     */
    selectAll() {
      var that = this;
      this.selectedAll = false;
      this.goodsListArr.forEach((item) => {
        if (item.info.status == 1 && item.info.isPcGoods == 1) {
          if (item.info.isSelected == false) {
            that.selectedAll = true;
          }
        }
      });
      that.goodsNum = 0;
      that.goodsPrice = 0;
      that.goodsListArr.forEach((item) => {
        if (item.info.status == 1 && item.info.isPcGoods == 1) {
          // var info = JSON.parse(JSON.stringify(item.info));
          if (that.selectedAll) {
            // if (item.info.isSelected == false) {
            //   info.isSelected = true;
            //   that.editShopCar(item.id, info);
            // }
            item.info.isSelected = true;
            that.goodsNum += item.info.num;
            that.goodsPrice += item.info.wholesalePrice * item.info.num;
          } else {
            // if (item.info.isSelected == true) {
            //   info.isSelected = false;
            //   that.editShopCar(item.id, info);
            // }
            item.info.isSelected = false;
          }
        }
      });
    },
    //增加数量
    addNum(index, id, info) {
      var that = this;
      var price = 0;
      this.$set(
        this.goodsListArr[index].info,
        "num",
        this.goodsListArr[index].info.num + 1
      );
      that.goodsListArr[index].info.intervalPriceList.forEach((item, ind) => {
        if (
          ind == that.goodsListArr[index].info.intervalPriceList.length - 1 &&
          that.goodsListArr[index].info.num >= item.startNum
        ) {
          price = item.price;
          return;
        } else if (
          ind != that.goodsListArr[index].info.intervalPriceList.length - 1 &&
          that.goodsListArr[index].info.num >= item.startNum &&
          that.goodsListArr[index].info.num <= item.endNum
        ) {
          price = item.price;
          return;
        }
      });
      this.$set(this.goodsListArr[index].info, "wholesalePrice", price);
      this.editShopCar(id, this.goodsListArr[index].info);

      var shopCarNum = 0;
      this.goodsListArr.forEach((x) => {
        shopCarNum += x.info.num; //计算购物车商品总数
      });
      that.totalNum = shopCarNum;
      this.$store.commit("saveShopCarNum", shopCarNum);

      if (this.goodsListArr[index].info.isSelected) {
        that.goodsNum = 0;
        that.goodsPrice = 0;
        this.goodsListArr.forEach((item) => {
          if (item.info.status == 1 && item.info.isPcGoods == 1) {
            if (item.info.isSelected) {
              that.goodsPrice += item.info.wholesalePrice * item.info.num;
              that.goodsNum += item.info.num;
            }
          }
        });
      }
    },
    //减少数量
    reduceNum(index, id, info) {
      var that = this;
      if (
        this.goodsListArr[index].info.num ==
        // (that.goodsListArr[index].info.pcMinBuyCount
        //   ? that.goodsListArr[index].info.pcMinBuyCount
        //   : that.goodsListArr[index].info.minBuyCount)
        that.goodsListArr[index].info.intervalPriceList[0].startNum
      ) {
        return;
      }
      this.$set(
        this.goodsListArr[index].info,
        "num",
        this.goodsListArr[index].info.num - 1
      );
      var price = 0;

      that.goodsListArr[index].info.intervalPriceList.forEach((item, ind) => {
        if (
          ind == that.goodsListArr[index].info.intervalPriceList.length - 1 &&
          that.goodsListArr[index].info.num >= item.startNum
        ) {
          price = item.price;
          return;
        } else if (
          ind != that.goodsListArr[index].info.intervalPriceList.length - 1 &&
          that.goodsListArr[index].info.num >= item.startNum &&
          that.goodsListArr[index].info.num <= item.endNum
        ) {
          price = item.price;
          return;
        }
      });
      this.$set(this.goodsListArr[index].info, "wholesalePrice", price);
      this.editShopCar(id, this.goodsListArr[index].info);

      var shopCarNum = 0;
      this.goodsListArr.forEach((x) => {
        shopCarNum += x.info.num; //计算购物车商品总数
      });
      that.totalNum = shopCarNum;
      this.$store.commit("saveShopCarNum", shopCarNum);
      if (this.goodsListArr[index].info.isSelected) {
        that.goodsNum = 0;
        that.goodsPrice = 0;
        this.goodsListArr.forEach((item) => {
          if (item.info.status == 1 && item.info.isPcGoods == 1) {
            if (item.info.isSelected) {
              that.goodsPrice += item.info.wholesalePrice * item.info.num;
              that.goodsNum += item.info.num;
            }
          }
        });
      }
    },
    /**
     * 输入数量，检测阶梯价格
     */
    changeNum(index, id, info) {
      var that = this;
      if (
        this.goodsListArr[index].info.num <
        // (that.goodsListArr[index].info.pcMinBuyCount
        //   ? that.goodsListArr[index].info.pcMinBuyCount
        //   : that.goodsListArr[index].info.minBuyCount)
        that.goodsListArr[index].info.intervalPriceList[0].startNum
      ) {
        this.$set(
          this.goodsListArr[index].info,
          "num",
          // that.goodsListArr[index].info.pcMinBuyCount
          //   ? that.goodsListArr[index].info.pcMinBuyCount
          //   : that.goodsListArr[index].info.minBuyCount
          that.goodsListArr[index].info.intervalPriceList[0].startNum
        );
      }
      var price = 0;
      this.goodsListArr[index].info.intervalPriceList.forEach((item, ind) => {
        if (
          ind == this.goodsListArr[index].info.intervalPriceList.length - 1 &&
          this.goodsListArr[index].info.num >= item.startNum
        ) {
          price = item.price;
          return;
        } else if (
          ind != this.goodsListArr[index].info.intervalPriceList.length - 1 &&
          this.goodsListArr[index].info.num >= item.startNum &&
          this.goodsListArr[index].info.num <= item.endNum
        ) {
          price = item.price;
          return;
        }
      });
      this.$set(this.goodsListArr[index].info, "wholesalePrice", price);
      this.editShopCar(id, this.goodsListArr[index].info);
      var shopCarNum = 0;
      this.goodsListArr.forEach((x) => {
        shopCarNum += x.info.num; //计算购物车商品总数
      });
      that.totalNum = shopCarNum;
      this.$store.commit("saveShopCarNum", shopCarNum);
      if (this.goodsListArr[index].info.isSelected) {
        that.goodsNum = 0;
        that.goodsPrice = 0;
        this.goodsListArr.forEach((item) => {
          if (item.info.status == 1 && item.info.isPcGoods == 1) {
            if (item.info.isSelected) {
              that.goodsPrice += item.info.wholesalePrice * item.info.num;
              that.goodsNum += item.info.num;
            }
          }
        });
      }
    },
    /**
     * 修改购物车
     */
    editShopCar(id, info) {
      var that = this;
      var data = {
        num: info.num,
        id: info.id,
        isSelected: info.isSelected,
      };
      doGet(
        httpConfig.shopCar.saveShopCarUrl,
        {
          id,
          info: JSON.stringify(data),
          type: 0,
        },
        function (res) {
          if (res.flag) {
          }
        },
        function (res) {}
      );
    },
    /**
     * 删除单个商品
     */
    deleteGoods(index, id) {
      var that = this;
      this.$confirm("确认删除？")
        .then((_) => {
          doGet(
            httpConfig.shopCar.deleteShopCarUrl,
            {
              id,
              type: 0,
            },
            function (res) {
              if (res.flag) {
                that.goodsListArr.splice(index, 1);
                var shopCarNum = 0;
                that.goodsListArr.forEach((x) => {
                  shopCarNum += x.info.num; //计算购物车商品总数
                });
                that.$store.commit("saveShopCarNum", shopCarNum);

                that.getSelected();
                that.$message({
                  type: "success",
                  message: "删除成功!",
                });
              }
            },
            function (res) {}
          );
        })
        .catch((_) => {});
    },
    /**
     * 删除选中商品
     */
    deleteAll() {
      var that = this;
      if (
        this.goodsListArr.some(
          (x) =>
            x.info.status == 1 &&
            x.info.isSelected == true &&
            x.info.isPcGoods == 1
        )
      ) {
        this.$confirm("确认删除选中商品？")
          .then((_) => {
            var arr = [];
            for (var i = 0; i < that.goodsListArr.length; i++) {
              if (
                that.goodsListArr[i].info.status == 1 &&
                that.goodsListArr[i].info.isSelected &&
                that.goodsListArr[i].info.isPcGoods == 1
              ) {
                arr.push(that.goodsListArr[i].id);
              }
            }
            doGet(
              httpConfig.shopCar.batchDeleteShopCarUrl,
              {
                ids: arr.join(","),
                type: 0,
              },
              function (res) {
                if (res.flag) {
                  for (var i = 0; i < that.goodsListArr.length; i++) {
                    if (
                      that.goodsListArr[i].info.status == 1 &&
                      that.goodsListArr[i].info.isSelected &&
                      that.goodsListArr[i].info.isPcGoods == 1
                    ) {
                      that.goodsListArr.splice(i, 1);
                      i--;
                    }
                  }

                  var shopCarNum = 0;
                  that.goodsListArr.forEach((x) => {
                    shopCarNum += x.info.num; //计算购物车商品总数
                  });
                  that.$store.commit("saveShopCarNum", shopCarNum);

                  that.getSelected();
                  that.$message({
                    type: "success",
                    message: "删除成功!",
                  });
                }
              },
              function (res) {}
            );
          })
          .catch((_) => {});
      } else {
        this.$message({
          type: "warning",
          message: "请先勾选商品",
        });
      }
    },
    // 去结算
    goSettle() {
      var that = this;
      if (this.goodsNum == 0) {
        this.$message({
          type: "warning",
          message: "请先勾选商品",
        });
      } else {
        var arr = [];
        for (var i = 0; i < that.goodsListArr.length; i++) {
          if (
            that.goodsListArr[i].info.status == 1 &&
            that.goodsListArr[i].info.isSelected &&
            that.goodsListArr[i].info.isPcGoods == 1
          ) {
            arr.push(that.goodsListArr[i].id);
          }
        }
        this.$store.commit("saveBuyGoodsIds", arr);
        this.$store.commit("saveAddress", this.value);
        this.$router.push("/orderPay");
      }
    },
    //移入收藏
    addCollect(item) {
      var that = this;
      var flag = false;
      that.collectList.forEach((x) => {
        if (x.info.id == item.id) {
          flag = true;
        }
      });
      if (flag) {
        that.$message({
          type: "success",
          message: "已加入收藏夹",
        });
        return;
      }
      var data = {
        id: item.id,
        isSelected: false,
      };
      doGet(
        httpConfig.shopCar.saveShopCarUrl,
        {
          info: JSON.stringify(data),
          type: 1,
        },
        function (res) {
          if (res.flag) {
            that.getShopCar(1);
            that.$message({
              type: "success",
              message: "收藏成功",
            });
          }
        },
        function (res) {}
      );
    },
    /**
     * 获取地址列表
     */
    getAddressList() {
      var that = this;
      doGet(
        httpConfig.myAddress.getAddressUrl,
        {},
        function (res) {
          if (res.flag) {
            that.options = res.data;
            that.value =
              res.data.length != 0 ? JSON.parse(res.data[0].address).label : "";
          } else {
            that.$message({
              type: "error",
              message: res.message,
            });
          }
        },
        function (res) {}
      );
    },

    //关闭新增收货地址弹窗
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.resetForm("ruleForm");
          done();
        })
        .catch((_) => {});
    },
    //确认添加收货地址
    submitForm(formName) {
      var that = this;

      this.$refs[formName].validate((valid) => {
        if (valid) {
          var area =
            Object.values(this.ruleForm.area[0])[0] +
            Object.values(this.ruleForm.area[1])[0] +
            Object.values(this.ruleForm.area[2])[0] +
            Object.values(this.ruleForm.area[3])[0];
          // var areaCode = [
          //   Object.keys(this.ruleForm.area[0])[0],
          //   Object.keys(this.ruleForm.area[1])[0],
          //   Object.keys(this.ruleForm.area[2])[0],
          //   Object.keys(this.ruleForm.area[3])[0]
          // ];
          var shopAddress = JSON.parse(JSON.stringify(this.ruleForm));
          delete shopAddress.area;
          delete shopAddress.address;
          delete shopAddress.name;
          delete shopAddress.phone;
          // shopAddress["area"] = area;

          shopAddress["all"] = this.ruleForm.area;
          // shopAddress["areaCode"] = areaCode;
          shopAddress["label"] =
            this.ruleForm.name +
            " " +
            this.ruleForm.phone +
            " " +
            area +
            " " +
            this.ruleForm.address;

          doPost(
            httpConfig.myAddress.saveAddressUrl,
            {
              address: JSON.stringify(shopAddress),
              isDefault: that.isDefaultAdr ? 1 : 0,
            },
            function (res) {
              if (res.flag) {
                that.resetForm("ruleForm");
                that.getAddressList();
                that.$message({
                  message: "新增成功",
                  type: "success",
                });
              } else {
                that.$message({
                  type: "error",
                  message: res.message,
                });
              }
            },
            function (res) {}
          );
        } else {
          return false;
        }
      });
    },
    //取消添加收货地址
    resetForm(formName) {
      this.isDefaultAdr = false;
      this.$refs[formName].resetFields();
      this.isShowArea = false;
      var t = setTimeout(() => {
        this.isShowArea = true;
      }, 0);
      this.dialogVisible = false;
    },
    //点击新增收货地址
    showDialog() {
      if (this.options.length > 19) {
        this.$message({
          message: "最多可以添加20条地址，如需新增，请先删除一条",
          type: "warning",
        });
        return;
      }
      this.dialogVisible = true;
    },
    /**
     * 商品详情
     */
    gotoDetails(id) {
      this.$router.push({ path: "/goodsInfo", query: { id: id } });
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/shopCar";
</style>



// WEBPACK FOOTER //
// src/components/page/shopCar.vue